module.exports = __webpack_public_path__ + "img/Gill.41629670.png";